<template>
  <div class="content">
    <l-table
      ref="table"
      :tableConfig="tableConfig"
      @tableChange="tableChange"
      :searchParams="searchParams"
      emptyText="暂无选课数据"
      :emptyImgSrc="emptyImgSrc"
    >
      <template slot="searchConditions">
        <div>
          <a-input
            v-model="searchParams.keyword"
            placeholder="请输入课程名称关键词"
            allowClear
            @change="handleSearch"
          />
          <a-select
            v-model="searchParams.teacherId"
            placeholder="请选择授课老师"
            allowClear
            @change="handleSearch"
          >
            <a-select-option v-for="teacher in teacherList" :key="teacher.id" :value="teacher.id">
              {{ teacher.name }}
            </a-select-option>
          </a-select>
          <!-- <a-select
            v-model="selectedStatus"
            placeholder="请选择课程状态"
            allowClear
            @change="handleSearch"
          >
            <a-select-option value="1">待授课</a-select-option>
            <a-select-option value="2">授课中</a-select-option>
            <a-select-option value="3">已结束</a-select-option>
          </a-select> -->
        </div>
      </template>
      <template #status="{ record }">
        <div v-if="record.status === '1'" style="color: #269D78">待授课</div>
        <div v-if="record.status === '3'" style="color: #269D78">授课中</div>
        <div v-if="record.status === '4'" style="color: #999999">已结束</div>
      </template>
      <template #type="{ record }">
        <div v-if="record.type === '1'">线上</div>
        <div v-if="record.type === '2'">线下</div>
      </template>
      <template #operates="{ record }">
        <div class="operates">
          <a-button :disabled="record.status === '3' || record.status === '4'" type="link" @click="confirmSelection(record)" v-if="!record.isJoin">
            确认选课
          </a-button>
          <a-button :disabled="record.status === '3' || record.status === '4'" type="link" @click="cancelSelection(record)" v-else>
            取消选课
          </a-button>
        </div>
      </template>
      <template #filterDropdown>
        <div
          style="padding: 8px"
        >
          <a-cascader
            v-ant-ref="c => (courseTypeRef = c)"
            v-model="selectedCourseType"
            allowClear
            :options="courseTypeInfo"
            placeholder="请选择课程类型"
            :fieldNames="{ label: 'name', value: 'id', children: 'child' }"
            @change="selectedCourseTypeOk"
          />
        </div>
      </template>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="filter"
        theme="filled"
        :style="{ color: !filtered ? '#FFA000' : undefined }"
      />
      <template #serchTip>
        <p>请换一个搜索词吧~</p>
      </template>
      <template #statusName="{ record }">
        <span :style="{ color: record.status === '1' ? '#F06321' : '#2DB58B' }">{{ record.statusName }}</span>
      </template>
    </l-table>
    <TipModal
      @ok="handleConfirmOk"
      :visible="confirmVisible"
      @cancel="confirmVisible = false"
      :desc="`
        <p>确定要选择该课程吗？</p>
        <p class='placeholder'>${currentCourseName}</p>`" />
    <TipModal
      @ok="handleCancelOk"
      :visible="cancelVisible"
      @cancel="cancelVisible = false"
      :desc="`
        <p>确定要取消该课程吗？</p>
        <p class='placeholder'>${currentCourseName}</p>`" />
  </div>
</template>

<script>
import jsCookie from 'js-cookie'
import LTable from '@/components/LTable/index.vue'
import TipModal from '@/components/tipModal/index.vue'
import { selectCourse, cancelSelectCourse, getAllTeacher } from '@/api/lesson'

const userType = JSON.parse(jsCookie.get('user_type')).join(',')
export default {
  components: {
    LTable,
    TipModal
  },
  data() {
    return {
      table: null,
      keyword: '',
      courseTypeRef: null,
      tableConfig: {
        tableName: '',
        tableColumns: [
          {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 60
          },
          {
            title: '课程名称',
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: '授课老师',
            dataIndex: 'teacherName',
            key: 'teacherName',
            align: 'center'
          },
          {
            title: '实验类型',
            dataIndex: 'type',
            key: 'type',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filterMultiple: false,
            filters: [
              { text: '线上', value: '1' },
              { text: '线下', value: '2' }
            ],
            scopedSlots: {
              customRender: 'type'
            }
          },
          {
            title: '实验室名称',
            dataIndex: 'trainingRoomName',
            key: 'trainingRoomName',
            align: 'center'
          },
          {
            title: '课程状态',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 100,
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: '已结束', value: '4' },
              { text: '待授课', value: '1' },
              { text: '授课中', value: '3' }
            ],
            filterMultiple: false,
            scopedSlots: { customRender: 'status' }
          },
          {
            title: '授课时间',
            dataIndex: 'startTime',
            key: 'startTime',
            align: 'center'
          },
          {
            title: '操作',
            dataIndex: 'operates',
            key: 'operates',
            align: 'center',
            width: 180,
            customSlots: true,
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tablePort: {
          list: '/student/select-course/list'
        }
      },
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      visible: false,
      courseTypeInfo: [],
      selectedCourseType: [],
      courseTypeId: '',
      dateRange: null,
      searchParams: {
        keyword: '',
        teacherId: undefined
      },
      userType,
      emptyImgSrc: require('@/assets/img/pic_kh_select@2x.png'),
      confirmVisible: false,
      cancelVisible: false,
      currentCourseId: null,
      currentCourseName: '',
      selectedTeacher: undefined,
      selectedStatus: undefined,
      teacherList: []
    }
  },
  methods: {
    handleSearch() {
      this.$refs.table.getList({
        searchParams: {
          keyword: this.searchParams.keyword,
          teacherId: this.searchParams.teacherId
        },
        condition: {
          status: this.selectedStatus
        }
      })
    },
    async init() {
      try {
        const res = await getAllTeacher()
        this.teacherList = res.data.list || []
      } catch (error) {
        console.error('获取教师列表失败:', error)
      }
    },
    search() {},
    async confirmSelection(record) {
      this.currentCourseId = record.id
      this.currentCourseName = record.name
      this.confirmVisible = true
    },
    async cancelSelection(record) {
      this.currentCourseId = record.id
      this.currentCourseName = record.name
      this.cancelVisible = true
    },
    async handleConfirmOk() {
      try {
        await selectCourse({
          courseId: this.currentCourseId
        })
        this.$message.success('选课成功')
        this.$refs.table.getList()
      } catch (error) {
        this.$message.error('选课失败')
      } finally {
        this.confirmVisible = false
        this.currentCourseId = null
        this.currentCourseName = ''
      }
    },
    async handleCancelOk() {
      try {
        await cancelSelectCourse({
          courseId: this.currentCourseId
        })
        this.$message.success('已取消选课')
        this.$refs.table.getList()
      } catch (error) {
        this.$message.error('取消选课失败')
      } finally {
        this.cancelVisible = false
        this.currentCourseId = null
        this.currentCourseName = ''
      }
    },
    tableChange([filters, getList, sort]) {
      const { status, type } = filters
      getList({
        condition: {
          type,
          status: status && status[0]
        }
      })
    },
    selectedCourseTypeOk() {
      if (!this.selectedCourseType || this.selectedCourseType.length === 0) {
        this.$refs.table.getList({
          condition: {
            courseTypeId: []
          }
        })
        return
      }
      this.courseTypeId = this.selectedCourseType[this.selectedCourseType.length - 1]
      this.$refs.table.isDefaultQuery = false
      this.$refs.table.isDefaultSearch = false
      this.$refs.table.getList({
        condition: {
          courseTypeId: [this.courseTypeId]
        }
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 0px 19px;
  /deep/ .ant-btn-link:focus {
    // color: #5B7499;
  }
}
</style>

<style lang="less">
.l-form {
  .ant-form-item {
    margin-bottom: 0 !important;
    width: 250px;
    line-height: 30px;
  }
  .ant-form-item-label {
    margin-top: 10px;
  }
}
.l_filter_footer {
  border-top: solid 1px #e8e8e8;
  margin-top: 15px;
  padding-top: 10px;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  .ant-btn-link {
    color: #ff6d00;
    padding: 0;
    line-height: 1;
    height: auto;
  }
}
</style>
